
import { defineComponent } from 'vue';
import CustomAlert from '~/components/Alerts/Alert.vue';

export default defineComponent({
  name: 'PaymentAmountWarning',

  components: { CustomAlert },

  data: () => ({
    expanded: false,
  }),
});
